import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0h0.5v0.5h-0.5zM0.5,0h2v0.5h-2z' },
    { paint: 'trunk', d: 'M0,-2.5h1v0.5h-1zM0,-2h0.5v2h-0.5zM-1,0h1.5v0.5h-1.5z' },
    {
      paint: [
        ['snowCap', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-0.5,-2.5h0.5v2h-0.5zM-1,-0.5h1v0.5h-1z',
    },
    {
      paint: 'orchard',
      d: 'M0.5,-5.5h2v0.5h-2zM-1,-5h2v0.5h-2zM1.5,-5h1.5v0.5h-1.5zM-3,-4.5h0.5v0.5h-0.5zM-2,-4.5h2.5v0.5h-2.5zM2,-4.5h1v0.5h-1zM-1.5,-4h1.5v0.5h-1.5zM0.5,-4h0.5v0.5h-0.5zM1.5,-4h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['orchard', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M1,-5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-3,-4h1.5v0.5h-1.5zM0,-4h0.5v0.5h-0.5zM-2.5,-3.5h5v0.5h-5zM-1,-3h3v0.5h-3z',
    },
    {
      paint: [
        ['orchard', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-7h2v0.5h-2zM-1.5,-6.5h3.5v0.5h-3.5zM-2.5,-6h2.5v0.5h-2.5zM0.5,-6h2v0.5h-2zM-2.5,-5.5h3v0.5h-3zM-3,-5h1v0.5h-1zM-2.5,-4.5h0.5v0.5h-0.5zM1.5,-4.5h0.5v0.5h-0.5zM1,-4h0.5v0.5h-0.5z',
    },
    { paint: 'orangeFruit', d: 'M0,-6h0.5v0.5h-0.5zM-2,-5h1v0.5h-1zM1,-4.5h0.5v0.5h-0.5z' },
  ],
  pixels: 103,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0h0.5v0.5h-0.5zM0.5,0h2v0.5h-2z' },
    { paint: 'trunk', d: 'M-1.5,-3.5h1v0.5h-1zM0,-2h0.5v2h-0.5zM-1,0h1.5v0.5h-1.5z' },
    {
      paint: [
        ['snowCap', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-2.5,-5h0.5v0.5h-0.5zM-0.5,-2h0.5v1.5h-0.5zM-1,-0.5h1v0.5h-1z',
    },
    {
      paint: 'orchard',
      d: 'M-1.5,-7h1v0.5h-1zM0.5,-7h1.5v0.5h-1.5zM1.5,-6.5h0.5v0.5h-0.5zM-2.5,-6h0.5v0.5h-0.5zM2,-6h0.5v0.5h-0.5zM-3,-5.5h0.5v1.5h-0.5zM0.5,-5.5h0.5v0.5h-0.5zM2,-5.5h1v0.5h-1zM-1,-5h2v0.5h-2zM2,-5h1.5v0.5h-1.5zM-2,-4.5h5.5v0.5h-5.5zM-2,-4h0.5v0.5h-0.5zM-0.5,-4h1v0.5h-1zM1,-4h2v0.5h-2zM-3,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['orchard', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M1,-5.5h1v0.5h-1zM-3,-4h1v0.5h-1zM0.5,-4h0.5v0.5h-0.5zM-2.5,-3.5h1v0.5h-1zM-0.5,-3.5h0.5v0.5h-0.5zM1,-3.5h2v0.5h-2zM-2.5,-3h5v0.5h-5zM-0.5,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['orchard', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-0.5,-7h1v0.5h-1zM-1.5,-6.5h1v0.5h-1zM0,-6.5h1.5v0.5h-1.5zM-2,-6h1.5v0.5h-1.5zM0,-6h2v0.5h-2zM-2.5,-5.5h0.5v0.5h-0.5zM-1.5,-5.5h2v0.5h-2zM-1.5,-5h0.5v0.5h-0.5zM-2.5,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1z',
    },
    {
      paint: 'orangeFruit',
      d: 'M-0.5,-6.5h0.5v1h-0.5zM-2,-5.5h0.5v1h-0.5zM1,-5h1v0.5h-1zM0,-3.5h1v0.5h-1z',
    },
  ],
  pixels: 116,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant0];
